import React from 'react';
import './component.scss';
import Translate from '../translate/Translate';

export interface TsVideoPlayerPopupProps {
    videoLink?: string;
    isScreenMode?: boolean;
    onCloseVideo?: () => void;
    className?: string;
}

// Not an observer on purpose: it renders from plain props only, and mobx-react 5's observer
// wraps function components in a class, which breaks the hooks below
export const TsVideoPlayerPopup: React.FC<TsVideoPlayerPopupProps> = ({
    videoLink,
    isScreenMode = false,
    onCloseVideo,
    className
}) => {
    // Audio-only recordings render as a bare controls bar instead of a full-height frame,
    // so the layout switches to a compact centered player (detected from the loaded metadata).
    // Reset during render (not in useEffect) because a cached/fast-loading source can fire
    // loadedMetadata before a post-commit effect runs, and the deferred reset would then
    // clobber the correct true→false the metadata handler just set.
    const [isAudioOnly, setIsAudioOnly] = React.useState(false);
    const [prevVideoLink, setPrevVideoLink] = React.useState(videoLink);

    if (prevVideoLink !== videoLink) {
        setPrevVideoLink(videoLink);
        setIsAudioOnly(false);
    }

    const getVideoType = (link: string): string => {
        const path = link.split('?')[0];
        const ext = path.slice(path.lastIndexOf('.') + 1);

        return `video/${ext}`;
    };

    if (!videoLink) {
        return null;
    }

    return (
        <>
            {isScreenMode && <div className='screen' />}
            <div className={`video-recording-container ${isAudioOnly ? 'audio-only' : ''} ${className || ''}`}>
                <video
                    key={videoLink}
                    autoPlay
                    controls
                    onLoadedMetadata={(event) => setIsAudioOnly(event.currentTarget.videoWidth === 0)}>
                    <source type={getVideoType(videoLink)} src={videoLink} />
                    <Translate text={'HISTORY.VIEW.RECORDINGS_VIDEO_RECORDING_ERROR'} />
                </video>
                <div className='close-btn' onClick={onCloseVideo}>
                    <i className='glyphicon glyphicon-remove' />
                </div>
            </div>
        </>
    );
};
